import { render, staticRenderFns } from "./goodImport.vue?vue&type=template&id=76f1ecc9&scoped=true"
import script from "./goodImport.vue?vue&type=script&lang=js"
export * from "./goodImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f1ecc9",
  null
  
)

export default component.exports